import '.m{width:100%;}.ssr-plugin'
import '.a9{height:4px;}.ssr-plugin'
import '.ea{border-radius:8px;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.c2{overflow:hidden;}.ssr-plugin'
import '.fe{will-change:width;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.cf{top:0px;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled, Style } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { useLanguage } from '../hooks/useLanguage.js'

type MeterProps = {
  value: number
  simulated?: boolean
  style?: Style
}

export const Meter = ({ value, simulated = false, style }: MeterProps) => {
  const [stage, setStage] = useState(0)
  const [lang] = useLanguage()

  useEffect(() => {
    if (!simulated) return
    setStage(0)
    const t1 = setTimeout(() => setStage(1), 50)
    const t2 = setTimeout(() => setStage(2), 13050)
    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
    }
  }, [simulated])

  const simulatedValue = stage === 0 ? 0 : stage === 1 ? 75 : 95
  const displayValue = simulated ? simulatedValue : value
  const isSweeping = simulated && stage === 2
  const fillTransition = simulated
    ? 'width 13000ms ease-in-out, background-color 400ms ease'
    : 'width 250ms linear'

  return (
    <styled.div className="m a9 ea ai c2"
      style={{
        backgroundColor: `${transparentColor(colors.white, 0.15)}`,
        ...style,
      }}
    >
      <style>{`
        @keyframes meter-gradient-sweep {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
      <div className="fe a6 cf a9 ea"
        style={{
          width: `${Math.max(0, Math.min(100, displayValue))}%`,
          transition: fillTransition,
          left: lang.rtl ? 'auto' : 0,
          right: lang.rtl ? 0 : 'auto',
          background: isSweeping
            ? `linear-gradient(${lang.rtl ? 270 : 90}deg, ${colors.white} 15%, ${colors.orange} 50%, ${colors.white} 85%)`
            : colors.white,
          backgroundSize: isSweeping ? '200% 100%' : undefined,
          animation: isSweeping
            ? 'meter-gradient-sweep 2000ms ease-in-out infinite'
            : undefined,
        }}
      />
    </styled.div>
  )
}
